import { render, staticRenderFns } from "./WasteVisualizationSimple.vue?vue&type=template&id=792cf1b3&scoped=true&"
import script from "./WasteVisualizationSimple.vue?vue&type=script&lang=js&"
export * from "./WasteVisualizationSimple.vue?vue&type=script&lang=js&"
import style0 from "./WasteVisualizationSimple.vue?vue&type=style&index=0&id=792cf1b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792cf1b3",
  null
  
)

export default component.exports